import Image from 'next/image';
import Link from 'next/link';
import PropTypes from 'prop-types';
import { Box, Typography, makeStyles } from '@material-ui/core';

import LogoImage from '/public/home/teshig.png';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 6,
    },
});

const Logo = () => {
    const classes = useStyles();

    return (
        <Box className={classes.root}>
            <Link href="/home">
                <a>
                    <Image src={LogoImage} width={70} height={70} alt="logo image" />
                </a>
            </Link>
            <Box>
                <Typography
                    variant="h4"
                    style={{ color: 'white', fontWeight: 'bold', marginLeft: 20 }}
                >
                    БУЛГАН АЙМГИЙН
                </Typography>
                <Typography
                    variant="h1"
                    style={{ color: 'white', fontWeight: 'bold', marginLeft: 20, fontSize: 21, }}
                >
                    ТЭШИГ СУМ
                </Typography>
            </Box>
        </Box>
    );
};

Logo.propTypes = {
    className: PropTypes.string,
};

export default Logo;
